import { OTHER_CKBX_VAL } from "./OtherCheckboxUtils";

export const POSITION_BUTTONS = [ 
  {
    value: 'standing',
    label: 'Walking or standing',
    moreInfo: ''
  },
  {
    value: 'wheelchair',
    label: 'Using a wheelchair',
    moreInfo: ''
  },
  {
    value: 'recliner',
    label: 'Sitting in a recliner',
    moreInfo: ''
  },
  {
    value: 'desk',
    label: 'Using a desk/workstation',
    moreInfo: ''
  },
  {
    value: 'floor',
    label: 'Sitting or lying on the floor',
    moreInfo: ''
  },
  {
    value: 'bed',
    label: 'Lying in bed',
    moreInfo: ''
  },
  {
    value: OTHER_CKBX_VAL,
    label: 'Other',
    moreInfo: ''
  }
];

